import { useContext } from 'react'

import { AgGridContext } from '@/components/lemmala-design-system/table/contexts/ag-grid-context'
import { AgGridContextValue } from '@/components/lemmala-design-system/table/types'

export function useAgGridContext<TRowData = Record<string, unknown>>() {
  return useContext(AgGridContext) as AgGridContextValue<TRowData> | null
}
